<template>
    <slot
        :event-id="eventId"
        :tickets="tickets"
        :selected-ticket="selectedTicket"
        :add-to-cart-loading="addToCartLoading"
        :quantity="quantity"
        :gift-wrap="giftWrap"
        :gift-wrap-text="giftWrapText"
        :option-values="optionValues"
        :ticket="ticket"
        :is-in-cart="isInCart"
        :ticket-options="ticketOptions"
        :add-to-cart="addToCart"
    ></slot>
</template>

<script>
export default {
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        tickets: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedTicket: null,
            addToCartLoading: false,
            quantity: 1,
            giftWrap: false,
            giftWrapText: '',
            optionValues: {},
        };
    },

    computed: {
        ticket() {
            return this.tickets.find((ticket) => { return parseInt(ticket.id) === this.selectedTicket; });
        },
        isInCart() {
            return this.$store.getters['cart/isInCart'](this.selectedTicket);
        },
        ticketOptions() {
            return this.tickets.map((ticket) => {
                return {
                    value: ticket.id,
                    label: ticket.title,
                };
            });
        },
    },

    watch: {
        ticket: {
            deep: true,
            handler(newValue) {
                const optionValues = {};
                for (const option of newValue.options) {
                    if (option.type === 'checkboxes') {
                        optionValues[option.label] = [];
                    } else {
                        optionValues[option.label] = null;
                    }
                }

                this.optionValues = optionValues;
            },
        },
    },

    methods: {
        async addToCart() {
            if (this.isInCart) {
                location.href = '/shop/checkout';
                return;
            }

            this.addToCartLoading = true;

            await this.$store.dispatch('cart/addToCart', {
                id: this.selectedTicket,
                quantity: this.quantity,
                options: this.optionValues,
            });

            this.addToCartLoading = false;
        },
    },
};
</script>
